<template>
  <div class="homeShow">
    <el-button type="primary" class="btnClass" @click="submitForm">进入量表</el-button>
  </div>
</template>

<script>
export default {
  name: "homeShow",
  components: {},
  props: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    submitForm() {
      this.$router.push({ name: "guidance" });
    }
  }
};
</script>
<style lang="scss" scoped>
.homeShow {
  background-image: url("~@/assets/homeShow.png"); // 设置背景图片
  background-position: center;
  overflow: hidden;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 100vh;
  position: relative;
}
.btnClass {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>